const getPipeHeaderConfig = (variant) => {
  const variantsConfigs = {
    defaultConfig: [
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/" },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/" },
      { path: "/13-step/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/" },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/" },
      { path: "/25-step/" },
      { path: "/26-step/" },
      { path: "/27-step/" },
      { path: "/28-step/" },
      { path: "/29-step/" },
      { path: "/30-step/" },
      { path: "/31-step/" },
      { path: "/32-step/" },
    ],
    "Primary H1": [
      { path: "/ageRange/" },
      { path: "/howLongSinceIdealWeight/" },
      { path: "/additionalGoals/" },
      { path: "/designedToAdapt/" },
      { path: "/bodyType/" },
      { path: "/defineYourDiet/" },
      { path: "/foodAllergies/" },
      { path: "/featuredIn/" },
      { path: "/menopause/" },
      { path: "/workoutsPerWeek/" },
      { path: "/badHabits/" },
      { path: "/transformation/" },
      { path: "/snackingTriggers/" },
      { path: "/healthConditions/" },
      { path: "/moodSwings/" },
      { path: "/workingHours/" },
      { path: "/cookingPreferences/" },
      { path: "/age/" },
      { path: "/weAreBetter/" },
      { path: "/height/" },
      { path: "/weight/" },
      { path: "/targetWeight/" },
      { path: "/greatGoal/" },
      { path: "/firstName/" },
      { path: "/physiology/" },
      { path: "/metabolicAge/" },
      { path: "/suddenFlushes/" },
      { path: "/dryerSkin/" },
      { path: "/hormonalTherapy/" },
      { path: "/hormones/" },
      { path: "/potential/" },
      { path: "/getShape/" },
      { path: "/email/" },
    ],
  }

  return variantsConfigs[variant] || variantsConfigs.defaultConfig
}

export default getPipeHeaderConfig
